import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom, isDevMode } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';

// Pages
import { PagesRoutingModule } from '@pages/pages.routing';
import { PagesRouterOutletComponent } from './app/pages/pages.page';

// Modules
import { CoreModule } from '@core/core.module';

// Store (NgRx)
import { StoreModule } from '@ngrx/store';
import { themeReducer } from '@stores/theme-mode/theme-mode.reducer';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

bootstrapApplication(PagesRouterOutletComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            PagesRoutingModule,
            CoreModule,
            StoreModule.forRoot({ theme: themeReducer }),
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: (http: HttpClient) => new TranslateHttpLoader(http, './assets/lang/', '.json'),
                    deps: [HttpClient],
                },
            })
        ),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }).providers ?? [],
    ]
}).catch(err => console.error(err));
